/**
 * Дашборд «Обновление приложения» — версии мобилы у каждого юзера.
 *
 * Источник правды: миграция
 * `supabase/migrations/20260511120000_app_version_reporting.sql` в репо `stryzh`.
 * Колонки `profiles.app_version / app_build / app_platform /
 * app_version_updated_at` заполняются мобилой через RPC `report_app_version`
 * при старте и при логине. Здесь — read-only дашборд через RPC
 * `admin_list_app_versions` (под `is_admin()`).
 *
 * Этап 1: только просмотр. Блокеры и `min_supported_build` — отдельным шагом.
 */
import { createClient } from '@/api/supabase'

export type AppPlatform = 'ios' | 'android' | 'web'

export interface UserAppVersionRow {
  user_id: string
  full_name: string | null
  phone: string | null
  role: string | null
  app_version: string | null
  app_build: number | null
  app_platform: AppPlatform | null
  app_version_updated_at: string | null
}

export async function listAppVersions(): Promise<UserAppVersionRow[]> {
  const supabase = createClient()
  const { data, error } = await supabase.rpc('admin_list_app_versions')
  if (error) throw new Error(error.message)
  return (data ?? []) as UserAppVersionRow[]
}
